import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PaginatedResponse } from '@shared/components/model/paginated-response.model';
import { DossierFacturable } from '@features/demande-remboursement/choix-dossier/models/dossier-facturable.model';
import { DemandeRemboursement } from '@features/demande-remboursement/demande-remboursement/models/demande-remboursement';
import { DossiersSelectionne } from '@features/demande-remboursement/choix-dossier/models/dossier-selectionne.model';

export const MesDossiersActions = createActionGroup({
  source: 'Mes Dossiers Component',
  events: {
    getDossiersBySearchCriteriaSuccess: props<{ dossiers: PaginatedResponse<DossierFacturable> }>(),
    getDossiersBySearchCriteriaFailure: props<{ errorMessage: string }>(),
    updateDossiersSelectionnes: props<{ dossier: DossiersSelectionne }>(),
    resetDossiersSelectionnes: emptyProps(),
    createPaymentRequest: emptyProps(),
    createPaymentRequestSuccess: props<{ demandeRemboursement: DemandeRemboursement }>(),
    createPaymentRequestFailure: emptyProps(),
    resetForm: emptyProps(),
    isLoading: props<{ isLoading: boolean }>(),
    createPaymentRechercheDdpACompleterSuccess: emptyProps(),
    createPaymentRechercheDdpACompleterFailure: emptyProps(),
    createPaymentCompleterDdpSuccess: emptyProps(),
    createPaymentCompleterDdpModalSuccess: emptyProps(),
    createPaymentCompleterDdpModalFailure: emptyProps(),
    createPaymentRechercheDdpBrouillonSuccess: emptyProps(),
    createPaymentRechercheDdpBrouillonFailure: emptyProps(),
    createPaymentOuvrirDdpBrouillonSuccess: emptyProps(),
    createPaymentOuvrirDdpBrouillonFailure: emptyProps(),
    deleteFactureAfterNewDossier: props<{isFactureToDelete: boolean}>()
  }
});
